import store from '../store/index';

/*
updateBarcode is TRIGGERED FROM ANDROID WEBVIEW
IN ORDER TO UPDATE BARCODE text BASED BARCODE SCANNER RESULT
*/

window.updateBarcode = function(identifier, text) {
  if (identifier === 'DEPOSIT_TICKET_STORE') {
    store.commit('depositTicketStore/setScanCode', text);
  } else if (identifier === 'CLERK_PAYOUT_DEPOSIT_TICKET_STORE') {
    store.commit('clerkPayoutDepositTicketStore/setScanCode', text);
  } else if (identifier === 'CLERK_WAGER_STORE') {
    store.commit('clerkWagerStore/setScanCode', text);
  }
};

/*
  CALL ANDROID JS BRIDGE TO TRIGGER OPEN SCANNER CAMERA
*/
export function triggerBarcodeScannerCamera(identifier) {
  if (typeof Epos_Android_Interface != 'undefined') {
    if (Epos_Android_Interface.openBarcodeScanner != 'undefined') {
      Epos_Android_Interface.openBarcodeScanner(identifier);
    }
  }
}
